// https://github.com/angular/material/issues/1376
export default function /* @ngInject */ fixPasswordAutofill($timeout) {
    return function($scope, element) {
        let ua = navigator.userAgent;
        if (ua.match(/chrome/i) && !ua.match(/edge/i)) {
            $timeout(() => {
                if (element[0].querySelector('input[type=password]:-webkit-autofill')) {
                    element.addClass('md-input-has-value');
                }
            }, 100);
        }
    };
}



// WEBPACK FOOTER //
// ./forms/services/fix-password-autofill.js